const riot = require('riot');
riot.tag2('adstats', '<div class="card"> <div class="card-content"> <div class="field is-grouped is-flexwrap"> <div class="control"> <label class="label">Database</label> <div class="select is-small"> <select ref="db" name="db" onchange="{setDatabase}"> <option value="hb-2024-3" selected="{state.db==\'hb\'}">Live</option> <option value="hbdev" selected="{state.db==\'hbdev\'}">Devel</option> </select> </div> </div> <div class="control"> <label class="label">Time period</label> <div class="select is-small"> <select ref="period" name="period" onchange="{setPeriod}"> <option value="yester" selected="{state.period==\'yester\'}">Yesterday</option> <option value="today" selected="{state.period==\'today\'}">Today</option> <option value="last7" selected="{state.period==\'last7\'}">Last 7 days</option> <option value="last30" selected="{state.period==\'last30\'}">Last 30 days</option> <option value="month" selected="{state.period==\'month\'}">Previous month</option> <option value="custom" selected="{state.period==\'custom\'}">Custom</option> </select> </div> </div> <div class="control"> <label class="label">Start date</label> <input class="input is-small" ref="start_date" onchange="{setStartDate}" riot-value="{state.start_date}" placeholder="Start Date" title="Start date" type="{\'date\'}"> </div> <div class="control"> <label class="label">End date</label> <input class="input is-small" ref="end_date" onchange="{setEndDate}" riot-value="{state.end_date}" placeholder="End Date" title="End date" type="{\'date\'}"> </div> <div class="control"> <label class="label">&nbsp;</label> <input type="submit" class="button is-small {is-warning:state.dirty}" onclick="{submit}" value="Refresh"> </div> </div> <div class="field columns"> <div class="column"> <label class="label">Active dimensions</label> <virtual each="{dim, i in state.picked}"> <button class="button is-info is-small" onclick="{stash}">{dim}</button> </virtual> </div> <div class="column"> <label class="label">Inactive dimensions</label> <virtual each="{dim, i in state.stashed}"> <button class="button is-small" onclick="{pick}">{dim}</button> </virtual> </div> </div> </div> </div> <p>&nbsp;</p> <h3 class="title is-5">Performance report</h3> <div data-is="adgroupy" start="{state.start_date}" end="{state.end_date}T23:59:59.999Z" dimensions="{state.picked}"> </div>', '', '', function(opts) {
  var self = this,
      now = new Date(),
      day = now.getDate(),
      month = now.getMonth(),
      year = now.getFullYear(),
      today = new Date(year,month,day,12),
      yesterday = new Date(today.valueOf() - 1*24*3600*1000),
      ago7 = new Date(today.valueOf() - 7*24*3600*1000),
      ago30 = new Date(today.valueOf() - 30*24*3600*1000),
      month_start = new Date(year,month,1,12),
      last_start = month>0 ? new Date(year,month-1,1,12) : new Date(year-1,12+month-1,1,12),
      last_end = new Date(month_start.valueOf() - 24*3600*1000)

  var filters = api.get('filters'),
      state = filters['adstats'] = filters['adstats'] || {
        start_date: yesterday.toISOString().replace(/T.*$/,''),
        end_date: yesterday.toISOString().replace(/T.*$/,''),
        picked: ['_id.market','_id.publisher','_id.domain','_id.widget','_id.placement','_id.channel','_id.source'],
        stashed: ['_id.month','_id.week','_id.date','_id.hour','_id.mediaType','_id.type','_id.placement_size','_id.size'],
        metrics: [
          {label:'req.',field:'requests'},
          {label:'bids',field:'bid_requests'},
          {label:'resp',field:'bid_responses'},
          {label:'imp.',field:'impressions'},
          {label:'view',field:'viewable_impressions'},
          {label:'clk',field:'clicks'},
          {label:'cpm',field:'total_cpm'},
          {label:'brt',field:'revenue'},
          {label:'net',field:'net_revenue'},
        ],
        db:'hb',
        period: 'yester',
        dirty: false
      }

  self.state = state
  self.metrics = state.metrics

  self.title_style = 0

  this.setDatabase = function(e) {
    e.preventDefault()
    state.db = self.refs.db.value
    state.dirty = true
    console.log('state.db',state.db)
  }.bind(this)
  this.setStartDate = function(e) {
    e.preventDefault()
    state.start_date = self.refs.start_date.value
    state.period = 'custom'
    state.dirty = true
    console.log('state.start_date',state.start_date)
  }.bind(this)
  this.setEndDate = function(e) {
    e.preventDefault()
    state.end_date = self.refs.end_date.value
    state.period = 'custom'
    state.dirty = true
    console.log('state.end_date',state.end_date)
  }.bind(this)
  this.setPeriod = function(e) {
    state.period = e.target.value
    switch (state.period) {
      case 'month':
        state.start_date = last_start.toISOString().replace(/T.*$/,'')
        state.end_date = last_end.toISOString().replace(/T.*$/,'')
        break;
      case 'last30':
        state.start_date = ago30.toISOString().replace(/T.*$/,'')
        state.end_date = today.toISOString().replace(/T.*$/,'')
        break;
      case 'custom':
        break;
      case 'last7':
        state.start_date = ago7.toISOString().replace(/T.*$/,'')
        state.end_date = today.toISOString().replace(/T.*$/,'')
        break;
      case 'today':
        state.start_date = today.toISOString().replace(/T.*$/,'')
        state.end_date = today.toISOString().replace(/T.*$/,'')
        break;
      case 'yester':
      default:
        state.start_date = yesterday.toISOString().replace(/T.*$/,'')
        state.end_date = yesterday.toISOString().replace(/T.*$/,'')
    }
    state.dirty = true
  }.bind(this)

  self.dimension_service = {

    '_id.publisher': {oid: false, action: ids => api.service('publishers').find({query:{_id:{$in:ids},$select:['name'],$limit:ids.length}}).then(r => {
      console.log('publisher lookup',ids,r)
      return r.data
    }) },

    '_id.placement': {oid: false, action: ids => {
        ids = ids.map(id => id.toString())
        return api.service('placements').find({query:{placementId:{$in:ids},$select:['_id','placementId','placementName'],$limit:5000}}).then(r => {
          console.log('placements lookup',ids,r)
          var placementDict = {}
          r.data.forEach(d => d.placementId.forEach( placementId => {
            placementId = placementId.toString()
            placementDict[placementId] = placementDict[placementId] || {_id:placementId,name:new Set()}
            placementDict[placementId].name.add(d.placementName || d._id)
          }))
          console.log('placementDict',placementDict)
          var res = Object.values(placementDict).map(d => {d.title = Array.from(d.name).join(', '); d.name = '#'+d._id; return d});
          console.log('res',res)
          return res
        })
      }
    },
    '_id.widget': { oid: false, action: ids => {
      return api.service('ce-widgets').find({query:{"_id.id":{$in:ids},$select:['name'],$limit:5000}}).then(r => {
        console.log('widgets lookup',ids)
        var widgetDict = {}
        return r.data.map( d => {
          var admin_url = d._id.admin=='bexrt' ? '' : d._id.admin=='si' ? 'admin' : 'admin_'+d._id.admin,
              link = d._id.admin=='bexrt' ? '' : `https://${admin_url}.contentexchange.me/widgets/${d._id.id}/edit`;
          return {_id: d._id.id,name: d._id.admin+'#'+d._id.id,title: d.name, link: link}
        })
      })
    }},
    '_id.placement_size': {oid: false, action: ids => ids.map(val => val=='any' ? val : ({_id:val,name:val[0]+'x'+val[1]})) },
    '_id.size':  {oid: false, action: ids => ids.map(val => val=='any' ? val : ({_id:val,name:val[0]+'x'+val[1]})) },
  }

  this.pick = function(e) {
    e.preventDefault()
    state.stashed = state.stashed.filter(d => d!=e.item.dim)
    state.picked.push(e.item.dim)
    state.dirty = true
  }.bind(this)
  this.stash = function(e) {
    e.preventDefault()
    state.picked = state.picked.filter(d => d!=e.item.dim)
    state.stashed.push(e.item.dim)
    state.dirty = true
  }.bind(this)
  this.submit = function(e) {
    e.preventDefault()
    state.dirty = false
    self.tags.adgroupy.trigger( 'filter', {db:state.db,start:state.start_date,end:state.end_date,dimensions:state.picked} )
  }.bind(this)

});

riot.tag2('adgroupy', '<div class="xcolumns head"> <div class="xcolumn is-20-desktop" riot-style="padding-left:{title_style}px"> {dimensions[0]} <span> <i class="fas fa-angle-up is-pointer is-hover-red {has-text-info:state.sortby==\'_id\' && state.order==1}" onclick="{setSort(\'_id\',1)}"></i> <i class="fas fa-angle-down is-pointer is-hover-red {has-text-info:state.sortby==\'_id\' && state.order==-1}" onclick="{setSort(\'_id\',-1)}"></i> </span> <span class="tags are-small is-pulled-right"> <a onclick="{expandAll}" class="tag">+</a> <a onclick="{closeAll}" class="tag">-</a> <a onclick="{recursive}" class="tag">CSV</a> </span> </div> <div class="xcolumn metric" each="{m in metrics}">{m.label} <span> <i class="fas fa-angle-up is-pointer is-hover-red {has-text-info:state.sortby==m.field && state.order==1}" onclick="{setSort(m.field,1)}"></i> <i class="fas fa-angle-down is-pointer is-hover-red {has-text-info:state.sortby==m.field && state.order==-1}" onclick="{setSort(m.field,-1)}"></i> </span> </div> </div> <virtual each="{datalist}"> <div class="expandable xcolumns" onclick="{expand}"> <div class="xcolumn is-20-desktop" riot-style="padding-left:{title_style}px" title="{getTitle(_id)}"> {getValue(_id) || \'(empty)\'} <span onclick="{togglePin(dimensions[0],_id)}" class="{has-text-danger: state.pinned===_id}">&#x25cf;</span><br> <small> {getTitle(_id).slice(0,100)} <a if="{getLink(_id)}" href="{getLink(_id)}" target="_blank"><i class="fa fa-external-link-alt" aria-hidden="true"></i> edit</a> </small> </div> <div class="xcolumn metric" title="{requests}">{Math.round(requests).toLocaleString()}</div> <div class="xcolumn metric"> {Math.round(bid_requests).toLocaleString()} <span title="biddable requests">{percent(bid_requests,requests)}</span> </div> <div class="xcolumn metric"> {Math.round(bid_responses).toLocaleString()} <span title="fill rate">{percent(bid_responses,bid_requests)}</span> </div> <div class="xcolumn metric"> {Math.round(impressions).toLocaleString()} <span title="win rate">{percent(impressions,bid_requests)}</span> </div> <div class="xcolumn metric"> {Math.round(viewable_impressions).toLocaleString()} <span title="view rate">{percent(viewable_impressions,bid_requests)}</span> </div> <div class="xcolumn metric"> {clicks.toLocaleString()} <span title="CTR">{percent(clicks,impressions)}</span> </div> <div class="xcolumn metric"> {(total_cpm/1000).toFixed(3)} <span title="{(min_cpm).toFixed(3)} - {(max_cpm).toFixed(3)}">{cpm(total_cpm,1000*bid_responses)}</span> </div> <div class="xcolumn metric"> {revenue.toFixed(3)} <span title="cpm">{cpm(revenue,impressions)}</span> </div> <div class="xcolumn metric"> {net_revenue.toFixed(3)} <span title="net cpm">{cpm(net_revenue,impressions)}</span> </div> </div> <adgroupy if="{state.expanded.get(_id)}" start="{start}" end="{end}" dimensions="{makeDimensions(_id)}" filter="{makeFilter(_id)}" path="{makePath(_id)}" id="{_id}"> </adgroupy> </virtual>', '', '', function(opts) {
  var self = this,
      dimensions = opts.dimensions || [],
      metrics = self.parent.metrics,
      dim = dimensions[0],
      topstate = self.parent.state,
      state = topstate[dim] = topstate[dim] || {
        expanded: new Map(),
        pinned: false,
        sortby: '_id',
        order: 1
      };

  state.db = topstate.db
  self.state = state
  self.dimensions = dimensions || []

  self.percent = (s,t) => t ? (100*s/t).toFixed(2)+'%' : '0%'
  self.cpm = (a,b) => a ? (1000*a/b).toFixed(3) : 0

  self.on('mount',function() {
    self.start = opts.start
    self.end = opts.end
    self.dimensions = dimensions || []
    self.metrics = metrics || []
    self.datalist = []
    self.path = opts.path || []
    self.filter = opts.filter || {
      $and: [
        {'_id.date':{$gte:{_date:self.start}}},
        {'_id.date':{$lte:{_date:self.end}}},
      ]
    }
    if (state.pinned) self.filter[dim] = state.pinned;
    else console.log('no pin on mount for',dim);
    console.log('mount',opts,self.dimensions)

    if (self.dimensions.indexOf('_id.source')!=0) {
      if (!self.filter['_id.source'] || self.filter['_id.source'].$ne) self.filter['_id.source'] = 'total'
    } else self.filter['_id.source'] = {$ne:'total'};
    if (self.dimensions.indexOf('_id.channel')!=0) {
      if (!self.filter['_id.channel'] || self.filter['_id.channel'].$ne) self.filter['_id.channel'] = 'any'
    } else self.filter['_id.channel'] = {$ne:'any'};

    if (self.dimensions.indexOf('_id.type')!=0) {
      if (!self.filter['_id.type'] || self.filter['_id.type'].$ne) {
        self.filter['_id.type'] = 'any';
        self.filter['_id.mediaType'] = 'any';
      }
    } else {
      self.filter['_id.type'] = {$ne:'any'};
      self.filter['_id.mediaType'] = {$ne:'any'};
    }

    if (self.dimensions.indexOf('_id.size')!=0) {
      if (!self.filter['_id.size'] || self.filter['_id.size'].$ne) self.filter['_id.size'] = 'any'
    } else self.filter['_id.size'] = {$ne:'any'}

    self.title_style = self.parent.title_style + 20
    self.dimension_service = self.parent.dimension_service
    self.dimension_names = new Map()
    self.dimension_titles = new Map()
    self.dimension_links = new Map()
    self.loadData(true)
    if (self.parent.datalist && self.parent.datalist.length) {
    console.log('parent datalist',self.parent.datalist,self)
	    self.parentItem = self.parent.datalist.find(d => d._id==self.opts.id)
	  	self.parentItem.sub = self
	  }
	  console.log('mounted',self)
  })

  self.on('unmount',function() {
    if (self.parentItem) self.parentItem.sub = null
  })

  self.on('filter',function(opts) {
    state.db = opts.db
    self.start = opts.start
    self.end = opts.end+'T23:59:59.999Z'
    self.dimensions = dimensions = opts.dimensions || []
    if (dim != dimensions[0]) {
      state.pinned = false
      dim = dimensions[0]
    }
    self.filter = {
      $and: [
        {'_id.date':{$gte:{_date:self.start}}},
        {'_id.date':{$lte:{_date:self.end}}},
      ]
    }
    console.log('updating',self.no_load,self.tags)
    if (state.pinned) self.filter[dim] = state.pinned;
    else console.log('no pin on fiter for',dim);

    if (self.dimensions.indexOf('_id.source')!=0) {
      if (!self.filter['_id.source'] || self.filter['_id.source'].$ne) self.filter['_id.source'] = 'total'
    } else self.filter['_id.source'] = {$ne:'total'};
    if (self.dimensions.indexOf('_id.channel')!=0) {
      if (!self.filter['_id.channel'] || self.filter['_id.channel'].$ne) self.filter['_id.channel'] = 'any'
    } else self.filter['_id.channel'] = {$ne:'any'};

    if (self.dimensions.indexOf('_id.type')!=0) {
      if (!self.filter['_id.type'] || self.filter['_id.type'].$ne) {
        self.filter['_id.type'] = 'any';
        self.filter['_id.mediaType'] = 'any';
      }
    } else {
      self.filter['_id.type'] = {$ne:'any'};
      self.filter['_id.mediaType'] = {$ne:'any'};
    }

    if (self.dimensions.indexOf('_id.size')!=0) {
      if (!self.filter['_id.size'] || self.filter['_id.size'].$ne) self.filter['_id.size'] = 'any'
    } else self.filter['_id.size'] = {$ne:'any'};

    self.loadData(true)
  })

  this.setSort = function(dim,ord) {
  	return function(e) {
  		e.preventDefault()
  		state.sortby = dim
  		state.order = ord
  		e.preventUpdate = true
  		self.loadData()
  	}
  }.bind(this)

  self.on('update',function(e) {
    self.datalist.forEach(d => {

      d.ctr=d.impressions && (100*d.clicks/d.impressions) || 0
    })
    self.datalist.sort( (a,b) => {
      var id = state.sortby,
      		ord = state.order,
	       	aa = id=='_id' ?  self.getValue(a[id]) : +a[id],
	       	bb = id=='_id' ?  self.getValue(b[id]) : +b[id]

      if (aa<bb) return -ord
      if (aa>bb) return ord
      return 0
    })

  })

  this.expand = function(e) {
    var t = e.target
    if (t.tagName=='A' || t.tagName=='SPAN' || t.tagName=='I') return;
    var dims = self.makeDimensions(e.item._id)
    if (!dims.length) return
    state.expanded.set(e.item._id,!state.expanded.get(e.item._id))
  }.bind(this)

  this.expandAll = function(e) {
    if (self.dimensions.length==1) return
    self.datalist.forEach(d => state.expanded.set(d._id,true))
    const tags = self.tags.adgroupy || [];
    for (let i=0;i<tags.length;i++) tags[i].expandAll()
  }.bind(this)

  this.closeAll = function(e) {
    state.expanded = new Map()
  }.bind(this)

  this.togglePin = function(dim,value) {
    return function(e) {
      e.preventDefault()
      e.stopPropagation()
      var old = state.pinned
      if (old === value) {
        state.pinned = false
        state.expanded.set(value,false)
        delete self.filter[dim]
      } else {
        state.expanded.set(value,true)
        self.filter[dim] = state.pinned = value
      }
      e.update = false
      self.loadData()
    }
  }.bind(this)

  this.makeDimensions = function(_id) {
    var dims = self.dimensions
    return dims.slice(1)
  }.bind(this)

  this.makeFilter = function(_id) {
    var f = {}, dim = self.dimensions[0], val = _id
console.log('make filter',dim,_id)
    if (dim=='_id.hour') {
      dim = '_id.date'
      val = {_date:_id}
    } else
    if (dim=='_id.date') {
      dim = '_id.date'
      val = {$gte:{_date:_id+'T00:00:00Z'},$lte:{_date:_id+'T23:59:59Z'}}
    } else if (dim=='_id.week') {
      dim = '_id.date'
      var start = new Date(_id),
          end = new Date(_id);
      end.setDate(end.getDate() + 7)
      start = start.toISOString().substr(0,10)
      end = end.toISOString().substr(0,10)
      val = {$gte:{_date:start+'T00:00:00Z'},$lt:{_date:end+'T00:00:00Z'}}
    } else if (dim=='_id.month') {
      var m = _id.split('-')
      if (12==m[1]) {m[1]=1; ++m[0]}
      else ++m[1]
      dim = '_id.date'
      val = {$gte:{_date:_id},$lte:{_date:m.join('-')}}
    }
    f[dim] = val
    return Object.assign({},self.filter,f)
  }.bind(this)
  this.makePath = function(_id) {
    var p = {}
    p[self.dimensions[0]] = self.getValue(_id)
    return Object.assign({},self.path,p)
  }.bind(this)

  this.getValue = function(id) {

    if (!id) return '(empty)'
    id = id.toString()
    return self.dimension_names.get(id) || id
  }.bind(this)

  this.getTitle = function(id) {

    if (!id) return '(empty)'
    id = id.toString()
    return self.dimension_titles.get(id) || ''
  }.bind(this)

  this.getLink = function(id) {

    if (!id) return '(empty)'
    id = id.toString()
    return self.dimension_links.get(id) || ''
  }.bind(this)
  function getCollectionNames(collection, start = new Date(), end = new Date()) {
    start = new Date(start);
    end = new Date(end);
    let d = new Date(start.getFullYear(), start.getMonth());
    let months = [];
    while (d <= end) {
      months.push(collection + '_' + d.getFullYear() + '_' + (1+d.getMonth()));
      d.setMonth(d.getMonth() + 1);
    }
    return months;
  }

  this.loadData = function() {
    const
      dim = self.dimensions[0],
      service = self.dimension_service[dim];

    self.group = {
      "_id": dim=='_id.date'
             ? { $substr: [ "$_id.date", 0, 10 ] }
             : dim=='_id.month'
               ? { $substr: [ "$_id.date", 0, 7 ] }
               : dim=='_id.hour'
                 ? "$_id.date"
                 : dim=='_id.week'
                   ? { $substr: [{$dateTrunc: {date:"$_id.date",unit:"week"}}, 0, 10] }
                   : "$" + dim
    }

    metrics.forEach( m => self.group[m.field] = {$sum:'$'+m.field})
    self.group['total_cpm'] = {$sum:'$total_cpm'}
    self.group['min_cpm'] = {$min: { $cond: { if: {$gt:["$total_cpm",0]}, then:{$divide:["$total_cpm",'$bid_responses']}, else: 10000 } } }
    self.group['max_cpm'] = {$max: { $cond: { if: {$gt:["$total_cpm",0]}, then: {$divide:["$total_cpm",'$bid_responses']},else: 0 } } }

    const
      collection = (dim=='_id.hour' || self.path['_id.hour']) ? 'statistics' : 'daystats',
      services = getCollectionNames(collection, self.start,self.end)
    console.log('load data',services,self.path,self.filter,self.group);

    preloader.inc()
    api.service('aggregate').find({
      query:{

        database: state.db=='hbdev' ? 'hbdev' : 'hb',
        service: services,
        pipe: [
          {$match: self.filter},
          {$group: self.group},
          {$sort: { _id: -1 }},
      ]},
    }).then( r => {
      console.log('aggregate result',r);
      preloader.dec()
      self.datalist = r
      if (r.length==0) state.expanded = new Map()
      if (self.dimension_service[dim]) {
        const
          ids = r.filter( d => ['null','other','undefined'].indexOf(d._id)<0).map(d => (service.oid ? {_oid:d._id} : d._id) )
console.log('dim ids',ids.length,service)
        preloader.inc()
        return service.action(ids)
      } else return []
    }).then(r => {
      preloader.dec()
console.log('imension names',r)
      r.forEach(d => self.dimension_names.set(d._id.toString(),d.name) )
      r.forEach(d => self.dimension_titles.set(d._id.toString(),d.title) )
      r.forEach(d => self.dimension_links.set(d._id.toString(),d.link) )
      self.update()
    }).catch( e => {
      preloader.dec()
      console.log('error aggregate',e);
      self.error = e.message
      self.update()
    })

  }.bind(this)

  function saveAs (filename, text) {
    var element = document.createElement('a');
    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
    element.setAttribute('download', filename);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  }

  this.download = function(e) {

    e.preventDefault()
    var s = self,
        dim = s.dimensions[0],
        file = dim+'_'+s.start+'-'+s.end+'.csv',
        head = [dim].concat(metrics.map(m => m.field)),
        data = s.datalist.map(d => [s.getValue(d._id)].concat(metrics.map(m => d[m.field])) )
    data.unshift(head)
    data = data.map(r => ['"' + r.join('","') + '"'])
    data = data.join('\n')

    saveAs(file,data);
  }.bind(this)

  function dfs(node,len,depth) {
    var rows = []
    node.datalist.forEach(sub => {
      var row = new Array(len).fill(''),
          title = node.getTitle(sub._id),
          lbl = node.getValue(sub._id);
      if (title) lbl = title.slice(0,50) + '\n' + lbl
      row[depth] = lbl
      row = row.concat(metrics.map(m => sub[m.field]))
      rows.push(row)
      if (sub.sub) rows = rows.concat(dfs(sub.sub,len,depth+1))
    })
    return rows
  }

  this.recursive = function(e) {
    var data = dfs(self,self.dimensions.length,0),
        file = (opts.path && Object.values(opts.path).join('-') || 'Table')
               + '_'
               + self.dimensions.join('-').replace(/_id\./g,'')
               + '_'
               + self.start + '-' + self.end + '.csv',
        head = [...self.dimensions].concat(metrics.map(m => m.field))

    data.unshift(head)
    data = data.map(r => ['"' + r.join('","') + '"'])
    data = data.join('\n')

    saveAs(file,data);
    console.log('subnodes',Object.values(self.filter),data)
  }.bind(this)

});

